import { GoogleLogin } from 'react-google-login';

const clientId = '508890783137-6r2bcmgrbhcr9dciqlpqog8998561mku.apps.googleusercontent.com'; // Replace with OUR Google Client ID

function Login() {

    const onSuccess = (res) => {
        console.log('[Login Success] currentUser:', res.profileObj);
    }

    const onFailure = (res) => {
        console.log('[Login Failed] res:', res);
    }

    return (
        <div id='signin-button'>
            <GoogleLogin
                clientId={clientId}
                buttonText="Log In"
                onSuccess={onSuccess}
                onFailure={onFailure}
                cookiePolicy={'single_host_origin'}
                isSignedIn={true}
            />
        </div>
    )
}

export default Login;

